import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=44da9572&scoped=true"
import script from "./billing.vue?vue&type=script&lang=js"
export * from "./billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da9572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44da9572')) {
      api.createRecord('44da9572', component.options)
    } else {
      api.reload('44da9572', component.options)
    }
    module.hot.accept("./billing.vue?vue&type=template&id=44da9572&scoped=true", function () {
      api.rerender('44da9572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agent/billing.vue"
export default component.exports